import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=312a49b8&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MyProfile.vue?vue&type=style&index=0&id=312a49b8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "312a49b8",
  "46ac3648"
  
)

export default component.exports